<script>
import SortableTable from "@components/SortableTable.vue";

export default {
  extends: SortableTable,
  components: {},
  props: {
    table: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    },
    lista: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: () => ({
    items: null,
    empty: true,
    page: 1,
    totalRows: 1,
    size: 20,
    sort: {
      sortBy: "id",
      sortOrder: "ASC"
    },
    hasItems: true,
    showModalDelete: false,
    itemRemove: null
  }),
  computed: {
    listaRetorno() {
      return this.lista;
    }
  },
  created() {},
  methods: {
    remove(val) {
      this.$emit("delete-table", val);
    },
    cancelRemove() {
      this.showModalDelete = false;
    },
    confirmRemove() {
      this.showModalDelete = false;
      this.remove(this.itemRemove);
    }
  },
  watch: {
    lista: function() {
      this.items = this.lista;
      if (this.items.length > 0) {
        this.hasItems = true;
      } else {
        this.hasItems = false;
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row mt-5 mb-2" v-show="!hasItems">
          <div class="col-md-12">Não foram encontrados registros.</div>
        </div>
        <div class="table-sm table " v-show="hasItems">
          <table class="table b-table table table-hover">
            <thead class="thead-primary">
              <tr>
                <th
                  class="columnheader"
                  scope="col"
                  @click="
                    changeSort(field.sortName, field.name, field.sortable)
                  "
                  v-for="field in fields"
                  :key="field.name + '.' + field.type"
                >
                  {{ field.description }}
                  <i
                    class="fas fa-sort-down ml-2"
                    v-show="
                      showSortDown(field.sortName, field.name, field.sortable)
                    "
                  />
                  <i
                    class="fas fa-sort-up ml-2"
                    v-show="
                      showSortUp(field.sortName, field.name, field.sortable)
                    "
                  />
                  <i
                    class="fas fa-sort ml-2"
                    style="color: lightgray"
                    v-show="
                      showSortNone(field.sortName, field.name, field.sortable)
                    "
                  />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody class="selected-table">
              <tr v-for="item in items" :key="item.id">
                <td
                  v-for="field in fields"
                  :key="field.name + '.' + field.type"
                  @click="callDetails(item.id)"
                >
                  {{ item[field.name] | formatField(field.type) }}
                </td>
                <td>
                  <!-- <div class="float-right">
                    <b-button
                      class="btn btn-sm btn-icon"
                      variant="danger"
                      v-on:click="(showModalDelete = true), (itemRemove = item)"
                      ><i class="fe-trash"
                    /></b-button>
                  </div> -->
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row" v-show="totalRows > 10">
            <div class="col-md-9 mt-1">
              <b-pagination
                v-model="page"
                pills
                :total-rows="totalRows"
                :per-page="size"
              />
            </div>
            <div class="col-md-3">
              <b-form-group
                id="size"
                label-cols-lg="7"
                label="Registros por página:"
              >
                <b-form-select v-model="size">
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list text-right">
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
